import {
    Filters,
    Flag,
    Logout,
    MessageCircleDots,
    Parking,
    ScanLicense,
    Scanner,
    Search,
    Signage,
    Terminal
} from '@wemolo/components/icons/system'
import React from 'react'
import { SidebarItem } from '../components'
import { useFlags } from 'launchdarkly-react-client-sdk'
interface SidebarBase {
    title: React.ReactNode
    itemId: string
}

export const getSidebarItems = () => {
    let routes: {
        title: React.ReactNode
        itemId: string
        subNav?: SidebarBase[]
    }[] = []
    const { eventMatchingPauseUser, testOccupancyApi } = useFlags()
    routes = [
        {
            title: <SidebarItem icon={<Search />} text={'Global Search'} />,
            itemId: '/globalSearch'
        },
        {
            title: <SidebarItem icon={<Parking />} text={'Parking lot'} />,
            itemId: '/lot'
        },
        {
            title: <SidebarItem icon={<Signage />} text={'Station'} />,
            itemId: '/station'
        },
        {
            title: <SidebarItem icon={<Scanner />} text={'Device'} />,
            itemId: '/device'
        },
        {
            title: <SidebarItem icon={<Filters />} text={'Search Configuration'} />,
            itemId: '/searchConfig'
        },
        {
            title: <SidebarItem icon={<ScanLicense />} text={'MLP'} />,
            itemId: '/mlp'
        },
        ...(eventMatchingPauseUser
            ? [
                  {
                      title: <SidebarItem icon={<Flag />} text={'Event Matching Pause'} />,
                      itemId: '/matchingFlag'
                  }
              ]
            : []),
        ...(testOccupancyApi
            ? [
                  {
                      title: <SidebarItem icon={<Terminal />} text={'Occupancy Api Test'} />,
                      itemId: '/occupancyApiTest'
                  }
              ]
            : []),
        {
            title: <SidebarItem icon={<MessageCircleDots />} text={'Feedback'} />,
            itemId: 'feedback'
        },
        {
            title: <SidebarItem icon={<Logout />} text={'Logout'} />,
            itemId: 'logout'
        }
    ]

    return routes
}
